import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get, isEmpty, isObject, transform } from "lodash";
import { rules } from "../../utils/shared-mixins/vuelidate-valid-mixin";
import MaterialInputValidationLoader from "./loaders/material-input-validation-loader";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "MaterialInput",
  components: {
    MaterialInputValidationLoader
  },
  inject: {
    $validator: {
      default: null
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    label: {
      type: String,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optional: {
      type: Boolean,
      default: false
    },
    customExpression: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: ""
    },
    className: {
      type: String,
      default: ""
    },
    validatorContext: {
      type: Object,
      default: null
    },
    onType: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: "text"
    },
    noLabel: {
      type: Boolean,
      default: false
    },
    noAutoComplete: {
      type: [Boolean, String],
      default: true
    },
    requiredIndicator: {
      type: Boolean,
      default: false
    },
    showTooltipMessage: {
      type: Boolean,
      default: false
    },
    clientLogin: {
      type: Boolean,
      default: false
    },
    hiddenLabel: {
      type: Boolean,
      default: false
    },
    labelFor: {
      type: String,
      default: ""
    },
    signupClient: {
      type: Boolean,
      default: false
    },
    innerInputClasses: {
      type: Array,
      default: () => ["form-control"]
    },
    labelColor: {
      type: String,
      default: "light-gray"
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localValue: this.getValue(this.value),
      expression: null,
      focused: this.clientLogin,
      autoFilled: false,
      labelValue: isEmpty(this.labelFor) ? uuidv4() : this.labelFor,
      profileDetailsEmailInput: ""
    };
  },
  computed: {
    $v() {
      return this.validatorContext || this.$parent.$v;
    },
    validation() {
      var _this$$validator;
      if (!isEmpty((_this$$validator = this.$validator) == null ? void 0 : _this$$validator.value)) return this.$validator.value;
      if (!this.expression) return {};
      if (this.$v && this.signupClient) return this.$v;
      return get(this.$v, this.expression) || {};
    },
    validationClasses() {
      const classes = [];
      if (!this.isValueEmpty) classes.push("form-control-filled");
      if (this.validation.$error) classes.push("error");
      if (this.isSoft) classes.push("soft");
      return classes.join(" ");
    },
    isValueEmpty() {
      if (isObject(this.value)) return isEmpty(this.value);
      return this.value === "" || this.value == null;
    },
    inputClasses() {
      return [this.validationClasses, this.className, ...this.innerInputClasses].join(" ");
    },
    labelClasses() {
      return {
        soft: this.isSoft,
        "d-none": this.hiddenLabel,
        [`text-${this.labelColor}`]: true
      };
    },
    displayError() {
      const {
        displayError
      } = transform(rules, (acc, value, rule) => {
        if (this.validation[rule] === false) {
          const isSoft = this.isSoftError(rule);
          acc.displayError = {
            isSoft,
            value: this.getErrorMessage(rule, value, isSoft ? "soft" : "full")
          };
        }
        if (acc.displayError) {
          // stop at first rule found
          return false;
        }
      }, {});
      return {
        isSoft: displayError == null ? void 0 : displayError.isSoft,
        message: displayError == null ? void 0 : displayError.value
      };
    },
    isSoft() {
      return this.displayError.isSoft;
    },
    message() {
      return this.displayError.message;
    },
    emitEventType() {
      return this.onType ? "input" : "change";
    },
    autoCompleteValue() {
      if (this.noAutoComplete) return this.noAutoComplete === true ? "off" : this.noAutoComplete;
      return null;
    },
    isTypeEmail() {
      return this.type === "email";
    }
  },
  watch: {
    localValue(value) {
      this.$emit("input", value);
      this.setDirty();
    },
    value(value) {
      this.localValue = this.getValue(value);
    },
    "validation.$model"(value, oldValue) {
      if ((value == null || _trimInstanceProperty(value).call(value) === "") && !this.clientLogin) this.setDirty();
      if (!oldValue && !value) return;
      if (!this.validation.$dirty) this.setDirty();
    }
  },
  mounted() {
    var _this$customExpressio;
    const model = this.$vnode.data.model;
    this.expression = (_this$customExpressio = this.customExpression) != null ? _this$customExpressio : model == null ? void 0 : model.expression;
  },
  methods: {
    blur() {
      this.$refs.profileDetailsEmailInput.blur();
    },
    isSoftError(rule) {
      var _this$validation$$par, _this$validation$$par2;
      if (isEmpty(this.validation)) return false;
      return (_this$validation$$par = (_this$validation$$par2 = this.validation.$params[rule]) == null ? void 0 : _this$validation$$par2.softError) != null ? _this$validation$$par : false;
    },
    setDirty() {
      var _this$validation$$tou, _this$validation;
      if (!this.optional) (_this$validation$$tou = (_this$validation = this.validation).$touch) == null ? void 0 : _this$validation$$tou.call(_this$validation);
    },
    handleChange({
      target
    }) {
      const value = this.getValue(target.value);
      this.localValue = value;
      this.$emit("change", value);
    },
    handleEnter() {
      this.$emit("enter");
    },
    handleInput({
      target
    }) {
      if (!this.onType) return;
      this.localValue = this.getValue(target.value);
    },
    getErrorMessage(rule, value, key) {
      if (typeof value[key] === "function") return value[key](this.validation.$params[rule]);
      return value[key];
    },
    handleFocus(event) {
      this.focused = true;
      this.$emit("focus", event);
    },
    handleBlur(event) {
      if (!this.clientLogin) {
        this.setDirty();
        this.focused = false;
        this.$emit("blur", event);
      }
    },
    getValue(value) {
      return this.isTypeEmail && !!value ? value.toLowerCase() : value;
    }
  }
});